module.exports = __webpack_public_path__ + "static/media/image (28).8ed15e41.jpg";